import React from "react";
import Prismic from "prismic-javascript";
import NotFound from "./NotFound";
import Loader from "./Loader";

export default class FocusAreas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notFound: false,
      list: []
    };
    if (props.prismicCtx) {
      this.fetchList(props);
    }
  }

  componentDidUpdate(prevProps) {
    // this.props.prismicCtx.toolbar();
    if (!prevProps.prismicCtx) {
      this.fetchList(this.props);
    }
  }

  fetchList(props) {
    return props.prismicCtx.api
      .query(
        // Get the blog posts in descending order
        Prismic.Predicates.at("document.type", "banners")
      )
      .then(res => {
        const list = res.results.filter(
          banner => banner.data.location === props.bannerLocation
        );

        this.setState({ list: list });
      });
  }

  render() {
    if (this.state.list.length > 0) {
      return (
        <div className="banner-list">
          {this.state.list.map((item, index) => {
            return (
              <div className="banner text-center mb-3" key={index}>
                <a href={item.data.link.url} target="_blank">
                  <img
                    src={item.data.image.url}
                    className="img-fluid"
                    alt="banner"
                  />
                </a>
              </div>
            );
          })}
        </div>
      );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <Loader />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Banners.js